/**
 * Config programme Fidélité carte (Pass) côté NG.
 * Miroir des champs merchant BonSpot (stamps V1) — sync via bridge.
 * Multi-règles : docs/EVOLUTION-PASS-MULTI-REGLES-CATEGORIES.md
 */

export type LoyaltyPassRewardType = 'percent' | 'fixed' | 'item';

export interface LoyaltyPassRewardConfig {
  type: LoyaltyPassRewardType;
  /** Pour percent / fixed (XAF). */
  value?: number;
  currency?: 'XAF';
  /** Libellé affiché (ex. « Soin offert », « −10 % »). */
  label: string;
}

/** Bornes alignées BonSpot (`loyaltyProgram.ts`). */
export const LOYALTY_PASS_MIN_VISITS = 2;
export const LOYALTY_PASS_MAX_VISITS = 20;
export const LOYALTY_PASS_DEFAULT_VISITS = 6;
export const LOYALTY_PASS_DEFAULT_CARD_COLOR = '#011A3B';

/** Multi-règles : seuil passages (tickets qualifiants). */
export const LOYALTY_PASS_RULE_MIN_VISITS = 1;
export const LOYALTY_PASS_RULE_MAX_VISITS = 50;
/** Multi-cat : minimum de catégories ciblées. */
export const LOYALTY_PASS_RULE_MIN_CATEGORIES = 2;

/**
 * - visit_count : +1 par ticket (toutes ventes), pas de catégories
 * - ticket_multi_category : +1 si le panier contient toutes les cats ciblées
 * - category_count : legacy (normalisé → visit_count)
 */
export type LoyaltyPassRuleType =
  | 'visit_count'
  | 'ticket_multi_category'
  | 'category_count';

export type LoyaltyPassCategoryKind = 'service' | 'product';

export type LoyaltyPassCategoryRef = {
  kind: LoyaltyPassCategoryKind;
  categoryId: string;
};

/** Remise multi-règles (pas de type `item` en V1.5). */
export type LoyaltyPassRuleReward = {
  type: 'percent' | 'fixed';
  value: number;
  label: string;
  discountBase?: 'eligible_lines' | 'whole_ticket';
};

/**
 * Règle avancée (capability NG).
 * Si `loyaltyPassProgram.rules` non vide → moteur multi-règles (legacy V1 ignoré pour l’earn).
 */
export type LoyaltyPassRule = {
  id: string;
  enabled: boolean;
  type: LoyaltyPassRuleType;
  /** Plus petit = prioritaire à égalité de montant. */
  priority: number;
  /** visit_count : [] ; multi : ≥2 cats toutes requises sur le ticket. */
  categories: LoyaltyPassCategoryRef[];
  /** Nb de tickets qualifiants avant award. */
  visitsRequired: number;
  /**
   * @deprecated Qualification = toutes les cats. Conservé pour lecture legacy.
   */
  minDistinctCategories?: number;
  reward: LoyaltyPassRuleReward;
  name: string;
};

/**
 * Programme simple V1 : N passages → récompense.
 * (cashback exclu en V1 NG — mutex avec cagnotte locale.)
 * + `rules` optionnel pour multi-règles catégories.
 */
export interface LoyaltyPassProgramConfig {
  enabled: boolean;
  visitsRequired: number;
  reward: LoyaltyPassRewardConfig;
  /** Couleur face carte (hex #RRGGBB). */
  cardColor?: string;
  updatedAt?: Date;
  /**
   * Règles avancées. Absentes / [] = mode legacy V1 (1 compteur global).
   * Non vides = mode multi-règles (D-MR / évolution Pass).
   */
  rules?: LoyaltyPassRule[];
}
